// Source UNIQUE des pages "de contenu" qu'un admin peut restreindre par membre.
//
// Tout chemin qui n'y figure PAS (Sécurité, Mon abonnement, connexion Stripe,
// espace owner…) est un accès ESSENTIEL / de compte : il reste TOUJOURS
// joignable (gardé uniquement par le rôle) et n'est jamais masqué par la
// restriction de pages. Sans ça, un membre restreint qui cliquait sur une de
// ces pages hors-liste était rebondi vers sa 1re page autorisée (bug
// "Sécurité / Mon abonnement / Connecter Stripe → Post-Chabat").
//
// Utilisé par : la modale de restriction (UsersSettingsPage), le garde de route
// (ProtectedRoute) et le filtrage de la sidebar (AppShell).
export const RESTRICTABLE_PAGES = [
  { path: "/dashboard",             label: "Tableau de bord" },
  { path: "/post-chabat",           label: "Post-Chabat" },
  { path: "/donors",                label: "Donateurs" },
  { path: "/pledges",               label: "Engagements" },
  { path: "/campaigns",             label: "Campagnes" },
  { path: "/cerfa",                 label: "Reçus Cerfa" },
  { path: "/kiddoush/manage",       label: "Kiddoush" },
  { path: "/communication",         label: "Communication" },
  { path: "/settings/users",        label: "Équipe (admin)" },
  { path: "/settings/organization", label: "Paramètres org. (admin)" },
];

const RESTRICTABLE_PATHS = RESTRICTABLE_PAGES.map((p) => p.path);

// Le chemin courant correspond-il à une page restreignable (ou une de ses
// sous-pages, ex. /donors/new sous /donors) ?
export function isRestrictablePath(pathname) {
  const path = (pathname || "").replace(/\/+$/, "") || "/";
  return RESTRICTABLE_PATHS.some((p) => path === p || path.startsWith(p + "/"));
}
